import React, { useEffect, useState } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Experts from "@/components/site/Experts";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import IntroLoader from "@/components/site/IntroLoader";
import { api } from "@/lib/api";
import { useLang, pick } from "@/lib/lang";

export default function Home() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);
  const { lang } = useLang();

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch((e) => setError(e.message));
  }, []);

  useEffect(() => {
    if (!content?.seo) return;
    const seo = content.seo;
    const title = pick(seo.title, lang);
    const description = pick(seo.description, lang);
    if (title) document.title = title;
    const setMeta = (attr, value, content_) => {
      let el = document.querySelector(`meta[${attr}='${value}']`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, value);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content_ || "");
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", seo.og_image || content.brand?.logo);
    setMeta("property", "og:locale", lang === "es" ? "es_US" : "en_US");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:image", seo.og_image || content.brand?.logo);
  }, [content, lang]);

  if (error) return null;

  const brand = content?.brand;

  return (
    <div className="grain min-h-screen bg-[#0A0A0A] text-white" data-testid="site-root" id="top">
      {brand?.logo && <IntroLoader logo={brand.logo} name={brand.name} />}

      {content && (
        <>
          <Nav brand={brand} />
          <Hero brand={brand} hero={content.hero} />
          <Experts experts={content.experts} />
          <Marquee text={content.marquee} />
          <Services services={content.services || []} />
          <Manifesto manifesto={content.manifesto} stats={content.stats || []} />
          <Gallery gallery={content.gallery || []} />
          <Testimonials testimonials={content.testimonials || []} />
          <Contact
            brand={brand}
            serviceArea={content.service_area || []}
            services={content.services || []}
          />
          <Footer brand={brand} />
          <WhatsAppFab brand={brand} />
        </>
      )}
    </div>
  );
}
